import {Skeleton} from "@project/design-system-web";
import {PageContainer} from "@project/layouts";

export function RolesPending() {
  return (
    <PageContainer>
      <div className="flex flex-col gap-4">
        <Skeleton className="h-8 w-32 rounded-md" />
        <Skeleton className="h-10 w-full rounded-md" />
        <Skeleton className="h-64 w-full rounded-md" />
      </div>
    </PageContainer>
  );
}
